import React, { useState } from "react";
import { sortedCountries, resolveCountryMeta } from "../../utilis/countryCurrency";

const GstSettingModal = ({
  show,
  onClose,
  onSave,
  loading,
  formData,
  setFormData,
  isEditing = false,
}) => {
  const [errors, setErrors] = useState({});

  if (!show) return null;

  const handleCountryChange = (countryName) => {
    const meta = resolveCountryMeta(countryName);
    setFormData((prev) => ({
      ...prev,
      country_name: meta.country_name,
      country_code: meta.country_code,
      currency_code: meta.currency_code,
    }));
  };

  const handleGstPercentageChange = (value) => {
    if (value === "") {
      setFormData((prev) => ({ ...prev, gst_percentage: "" }));
      return;
    }

    const num = Number(value);
    if (Number.isNaN(num)) return;

    if (num > 100) {
      setFormData((prev) => ({ ...prev, gst_percentage: "100" }));
      return;
    }

    if (num < 0) {
      setFormData((prev) => ({ ...prev, gst_percentage: "0" }));
      return;
    }

    setFormData((prev) => ({ ...prev, gst_percentage: value }));
  };

  const handleSubmitForm = () => {
    const newErrors = {};

    if (!formData.country_name) {
      newErrors.country_name = "Please select a country.";
    }
    if (!formData.country_code) {
      newErrors.country_code = "Country code is required.";
    }
    if (!formData.currency_code) {
      newErrors.currency_code = "Currency code is required for the selected country.";
    }
    if (
      formData.gst_percentage === "" ||
      formData.gst_percentage === null ||
      Number.isNaN(Number(formData.gst_percentage)) ||
      Number(formData.gst_percentage) < 0
    ) {
      newErrors.gst_percentage = "Please enter a valid GST percentage.";
    } else if (Number(formData.gst_percentage) > 100) {
      newErrors.gst_percentage = "GST percentage cannot exceed 100.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      onSave();
    }
  };

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={() => {
          setErrors({});
          onClose();
        }}
      />

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          style={{ maxWidth: "600px" }}
        >
          <div className="modal-content border-0 rounded-3">
            <div className="modal-header border-bottom p-3">
              <h5 className="modal-title fw-semibold text-white">
                {isEditing ? "Edit GST Setting" : "Add GST Setting"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => {
                  setErrors({});
                  onClose();
                }}
                disabled={loading}
                aria-label="Close"
              />
            </div>

            <div className="modal-body p-4">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label fw-medium">
                    Country <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={formData.country_name || ""}
                    onChange={(e) => handleCountryChange(e.target.value)}
                  >
                    <option value="">Please Select</option>
                    {sortedCountries.map((country) => (
                      <option key={country.IsoCode} value={country.value}>
                        {country.value}
                      </option>
                    ))}
                  </select>
                  {errors.country_name && (
                    <small className="text-danger mt-1 d-block">
                      {errors.country_name}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-medium">Country Code</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={formData.country_code || ""}
                    readOnly
                    placeholder="Auto-filled from country"
                  />
                  {errors.country_code && (
                    <small className="text-danger mt-1 d-block">
                      {errors.country_code}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-medium">Currency Code</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={formData.currency_code || ""}
                    readOnly
                    placeholder="Auto-filled from country"
                  />
                  {errors.currency_code && (
                    <small className="text-danger mt-1 d-block">
                      {errors.currency_code}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-medium">
                    GST Percentage <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    min="0"
                    max="100"
                    step="0.01"
                    placeholder="e.g. 10.00"
                    value={formData.gst_percentage}
                    onChange={(e) => handleGstPercentageChange(e.target.value)}
                  />
                  {errors.gst_percentage && (
                    <small className="text-danger mt-1 d-block">
                      {errors.gst_percentage}
                    </small>
                  )}
                  <small className="text-muted mt-1 d-block">
                    Maximum allowed value is 100%.
                  </small>
                </div>
              </div>
            </div>

            <div className="modal-footer border-top p-3 d-flex gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${isEditing ? "btn-primary" : "btn-success"} px-4`}
                onClick={handleSubmitForm}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    {isEditing ? "Updating..." : "Saving..."}
                  </>
                ) : isEditing ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GstSettingModal;
